import React from 'react';
import { Box, Button, Stack } from 'bumbag';
import _findIndex from 'lodash/findIndex';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _omitBy from 'lodash/omitBy';
import type { ReactElement } from 'react';

import { VERIFY_MEMBER_HEALTH_FUNDS_CODES } from '@medipass/utils/constants';
import sdk from '@medipass/web-sdk';

import HealthFundAccountForm from '../account/health-fund-accounts/HealthFundAccountForm';

// @ts-expect-error TS(7006): Parameter 'healthFundAccount' implicitly has an 'a... Remove this comment to see the full error message
function getHealthFundAccountInitialValues(healthFundAccount) {
  const issueDate = healthFundAccount.issueDay
    ? `${healthFundAccount.issueDay}/${healthFundAccount.issueMonth}/${healthFundAccount.issueYear}`
    : undefined;
  return { ...healthFundAccount, issueDate };
}

type Props = {
  allowSkipHealthFund?: boolean;
  children: ReactElement | any;
  isHealthFundUpdatesDisabled: boolean;
  enabled: boolean;
  funder?: Record<string, any>;
  initialHealthFundId?: string;
  initialHealthFundAccount?: Record<string, any>;
  onClickCancel?: (...args: Array<any>) => any;
  onClickReject?: (...args: Array<any>) => any;
  onSkipHealthFund?: (...args: Array<any>) => any;
  onSubmitHealthFund: (...args: Array<any>) => any;
  returnToCartUrl: string | undefined;
  state?: string;
  wrapper?: (...args: Array<any>) => any;
  firstName?: string;
  lastName?: string;
  initialDob?: string;
};
type State = {
  healthFundAccount: Record<string, any>;
};
export default class WithRequestHealthFund extends React.Component<Props, State> {
  static defaultProps = {
    allowSkipHealthFund: false,
    disableHealthFundUpdate: false,
    funder: undefined,
    initialHealthFundId: null,
    initialHealthFundAccount: {},
    onClickCancel: null,
    onClickReject: null,
    onSkipHealthFund: null,
    returnToCartUrl: undefined,
    state: 'create',
    wrapper: (children: any) => children,
    firstName: null,
    lastName: null,
    initialDob: null,
  };
  state = {
    healthFundAccount: {},
  };
  handleClickBack = () =>
    this.setState({
      // @ts-expect-error TS(2345): Argument of type '{ requireAuth: boolean; }' is no... Remove this comment to see the full error message
      requireAuth: false,
    });
  handleSubmitHealthFund = async (data: Record<string, any>, actions: Record<string, any>) => {
    const { onSkipHealthFund, onSubmitHealthFund } = this.props;

    if (!data.healthFundId) {
      onSkipHealthFund && onSkipHealthFund();
      return;
    }

    const issueDateArray = _get(data, 'issueDate', '').split('/');

    const healthFund = await sdk.healthfunds.getHealthFund(data.healthFundId, {
      requestConfig: {
        tokenType: 'session',
      },
    });

    if (VERIFY_MEMBER_HEALTH_FUNDS_CODES.includes(healthFund.code)) {
      const memberVerifyBody = _omitBy(
        {
          membershipNumber: data.membershipNumber,
          cardRank: data.cardRank,
        },
        _isEmpty,
      );

      if (data.dob) {
        const dateComponents = data.dob.split('/');

        if (dateComponents.length === 3) {
          memberVerifyBody.dobString = `${dateComponents[2]}-${dateComponents[1]}-${dateComponents[0]}`;
        }
      }

      if (_isEmpty(memberVerifyBody.dobString)) {
        memberVerifyBody.firstName = data.firstName;
        memberVerifyBody.lastName = data.lastName;
      }

      const verifyMemberResponse = await sdk.healthfunds.verifyMember(data.healthFundId, memberVerifyBody, {
        tokenType: 'session',
      });

      if (_get(verifyMemberResponse, 'memberVerified')) {
        data.cardNumber = verifyMemberResponse.cardNumber;
      } else {
        data.cardNumber = '';
        actions.setFieldError('dob', 'Please check information');
        actions.setFieldError('membershipNumber', 'Please check information');
        actions.setFieldError('cardRank', 'Please check information');
        throw new Error('Your membership details could not be verified, please check the details and try again.');
      }
    }

    // @ts-expect-error TS(7006): Parameter 'healthFund' implicitly has an 'any' typ... Remove this comment to see the full error message
    const hasHealthFundField = (healthFund, fieldId) => {
      // @ts-expect-error TS(2339): Property 'id' does not exist on type 'unknown'.
      return _findIndex(healthFund.cardFields, field => field.id === fieldId) >= 0;
    };

    let healthFundAccount = {
      healthFundId: data.healthFundId,
      healthFund,
    };
    ['membershipNumber', 'cardRank', 'cardIssueNumber', 'cardNumber'].forEach(fieldName => {
      if (hasHealthFundField(healthFund, fieldName)) {
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        healthFundAccount[fieldName] = data[fieldName];
      }
    });

    if (
      (hasHealthFundField(healthFund, 'issueDay') && hasHealthFundField(healthFund, 'issueMonth'),
      hasHealthFundField(healthFund, 'issueYear'))
    ) {
      // @ts-expect-error TS(2339): Property 'issueDay' does not exist on type '{ heal... Remove this comment to see the full error message
      healthFundAccount.issueDay = issueDateArray[0];
      // @ts-expect-error TS(2339): Property 'issueMonth' does not exist on type '{ he... Remove this comment to see the full error message
      healthFundAccount.issueMonth = issueDateArray[issueDateArray.length - 2];
      // @ts-expect-error TS(2339): Property 'issueYear' does not exist on type '{ hea... Remove this comment to see the full error message
      healthFundAccount.issueYear = issueDateArray[issueDateArray.length - 1];
    }

    // @ts-expect-error TS(2739): Type 'Dictionary<any>' is missing the following pr... Remove this comment to see the full error message
    healthFundAccount = _omitBy(healthFundAccount, _isEmpty);
    this.setState({
      healthFundAccount,
    });
    await onSubmitHealthFund({
      healthFundAccount,
    });
  };
  render = () => {
    const {
      allowSkipHealthFund,
      children,
      isHealthFundUpdatesDisabled,
      enabled,
      funder,
      initialHealthFundId,
      initialHealthFundAccount,
      onClickCancel,
      onClickReject,
      onSkipHealthFund,
      wrapper,
      returnToCartUrl,
      state,
      firstName,
      lastName,
      initialDob,
    } = this.props;
    return enabled
      ? // @ts-expect-error TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
        wrapper(
          <Box>
            <HealthFundAccountForm
              showFieldsIfUnsupported={false}
              unsupportedMessage="This health fund has not yet enabled digital claiming. You can still continue, however, there will be no benefit and you will have to pay fully out of pocket."
              funder={funder}
              isHealthFundUpdatesDisabled={isHealthFundUpdatesDisabled}
              returnToCartUrl={returnToCartUrl}
              initialValues={
                initialHealthFundId
                  ? {
                      healthFundId: initialHealthFundId,
                      firstName,
                      lastName,
                      dob: initialDob,
                      ...getHealthFundAccountInitialValues(initialHealthFundAccount),
                    }
                  : {
                      firstName,
                      lastName,
                      dob: initialDob,
                    }
              }
              isHealthFundRequired={state === 'create'}
              isSelfCheckoutSession
              isMobileTitle={false}
              isSubmitButtonInsideSection
              onSubmit={this.handleSubmitHealthFund}
              submitButtonRenderer={({ hasNoFund, isDisabled, isLoading }) => (
                <Stack spacing="major-1">
                  <Button
                    palette="secondary"
                    disabled={isLoading || (state === 'create' && isDisabled)}
                    isLoading={isLoading}
                    size="medium"
                    width="100%"
                    type="submit"
                  >
                    {hasNoFund ? 'No fund, pay full amount' : 'Continue'}
                  </Button>
                  {state === 'edit' && (
                    <Button onClick={onClickCancel} size="medium" width="100%" type="submit" disabled={isLoading}>
                      Cancel
                    </Button>
                  )}
                  {allowSkipHealthFund && state === 'create' && (
                    <Button
                      palette="secondary"
                      variant="outlined"
                      disabled={isLoading}
                      onClick={onSkipHealthFund}
                      width="100%"
                    >
                      Skip & pay full amount
                    </Button>
                  )}
                  {state === 'create' && (
                    <Button
                      palette="secondary"
                      variant="ghost"
                      onClick={onClickReject}
                      width="100%"
                      disabled={isLoading}
                    >
                      Cancel
                    </Button>
                  )}
                </Stack>
              )}
              title="Enter your health fund details"
            />
          </Box>,
        )
      : children;
  };
}
